import { z } from 'zod';
import { BaseSchema } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const ChoiceSchema = BaseSchema.extend({
  question: z.string().uuid(),
  value: z.string().nullable().default(null),
  label: z.string(),
  order: z.number(),
});

export type Choice = z.infer<typeof ChoiceSchema>;

export const ChoiceEntityQueryResultSchema = FlatModels.EntityControlModels.EntityQueryResultSchema.extend({
  entity: ChoiceSchema,
});

export type ChoiceEntityQueryResult = z.infer<typeof ChoiceEntityQueryResultSchema>;
